import { render } from "./healthSpecialistSection.vue?vue&type=template&id=28e69550&scoped=true"
import script from "./healthSpecialistSection.vue?vue&type=script&lang=js"
export * from "./healthSpecialistSection.vue?vue&type=script&lang=js"

import "./healthSpecialistSection.vue?vue&type=style&index=0&id=28e69550&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e69550"]])

export default __exports__